export const siteUrl = "https://dev-api-sif.vac.az/";
export const localUrl = "https://localhost:44362/";

export default siteUrl;
